// src/pages/users/CreateUserPage.tsx
import React from "react";
import { useNavigate } from "react-router-dom";

import CreateUserForm from "@/components/users/forms/CreateUserForm";
import { useCreateUserMutation } from "@/api/features/users/mutations";

import UserFormPage from "./components/UserFormPage";
import { mapUpsertToCreate, extractErrorMessage } from "./useUsersPage";

export default function CreateUserPage() {
  const navigate = useNavigate();
  const createMutation = useCreateUserMutation();
  const [error, setError] = React.useState<string | null>(null);

  return (
    <UserFormPage
      title="Add user"
      subtitle="Staff accounts sign in to the admin with the role you assign here."
    >
      <CreateUserForm
        onSubmit={(payload) => {
          setError(null);
          createMutation.mutate(mapUpsertToCreate(payload), {
            onSuccess: () => navigate("/hr/users"),
            onError: (err) => setError(extractErrorMessage(err)),
          });
        }}
        submitting={createMutation.isPending}
        onCancel={() => navigate("/hr/users")}
        errorMessage={error}
      />
    </UserFormPage>
  );
}
